module.exports = __webpack_public_path__ + "img/FB_IMG_1531638136983.15c63388.jpg";